// extracted by mini-css-extract-plugin
export default {"modal":"nga","heading":"oga","product":"pga","note":"qga","notetitle":"rga","notetext":"sga","line":"tga","plan":"uga","planimage":"vga","description":"wga"};
    if(module.hot) {
      // 1721922369211
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  